import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WhyChoose from "@/components/WhyChoose";
import Coverage from "@/components/Coverage";
import QuoteForm from "@/components/QuoteForm";
import Testimonials from "@/components/Testimonials";
import InstaShowcase from "@/components/InstaShowcase";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyCall from "@/components/StickyCall";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#050505] text-white">
      <Header />
      <Hero />
      <Services />
      <QuoteForm />
      <WhyChoose />
      <Coverage />
      <Testimonials />
      <InstaShowcase />
      <Contact />
      <Footer />
      <StickyCall />
    </main>
  );
}
